import React from "react";
import { Header } from "../components/Header";
import { Hero } from "../components/Hero";
import { EditorialMarquee } from "../components/EditorialMarquee";
import { CompanyIntro } from "../components/CompanyIntro";
import { BusinessVerticals } from "../components/BusinessVerticals";
import { KRVMartSection } from "../components/KRVMartSection";
import { WoodMartSection } from "../components/WoodMartSection";
import { FinMartSection } from "../components/FinMartSection";
import { BrandArchitecture } from "../components/BrandArchitecture";
import { AboutDetail } from "../components/AboutDetail";
import { VisionApproach } from "../components/VisionApproach";
import { CareersPartners } from "../components/CareersPartners";
import { Contact } from "../components/Contact";
import { FinalMessage, Footer } from "../components/Footer";

export default function Home() {
  return (
    <div className="bg-navy">
      <Header />
      <main>
        <Hero />
        <EditorialMarquee />
        <CompanyIntro />
        <BusinessVerticals />
        <KRVMartSection />
        <WoodMartSection />
        <FinMartSection />
        <BrandArchitecture />
        <AboutDetail />
        <VisionApproach />
        <CareersPartners />
        <Contact />
        <FinalMessage />
      </main>
      <Footer />
    </div>
  );
}
